<div class="ml-2 skill-advanced-search">
  <bpt-search *ngIf="isMasterDataLoaded" class="search-component" [placeholder]="'Search by Code, Name or Description'"
    [advancedSearch]="true" [searchControls]="searchControls" [search]="getSearchResults"
    [advancedSearchMethod]="getAdvancedSearchResults">
  </bpt-search>
</div>

<div *ngIf="hasUserSearched && isPanelHubDataAvailable" class="mt-2 skill-panel-hub-container">
  <app-panel-hub [config]="panelHubConfig" [pagedData]="pagedData" [activeView]="0"
    (panelHubStateChanged)="onPanelHubEvent($event)" (panelEventHub)="onPanelEventHubInitialized($event)">
    <ng-template #headerTemplate let-data="dataVar" let-viewMode="currentView">
      <div class="card skill-card">
        <div class="card-container">
          <div class="flex align-items-start justify-content-between gap-3 skill-card-header">
            <div class="overflow-ellipse flex-initial flex underline skill-header font-semibold card-header">
            <b pTooltip="{{data?.code}} {{data?.name}}">
              <a class="skill-link" (click)="openSkill(data?.code)">
                {{ data?.code ?? '' }}
                {{ (data?.name?.length > 90) ? (data?.name | slice:0:90) + '..' : data?.name }}
              </a>
            </b>
            </div>
            <div class="flex-initial flex align-items-center font-semibold icon-alignment skill-status-container">
              <i class="pi pi-circle-fill status-dot" [ngClass]="(data?.isActive ?? false) ? 'active' : 'inactive'"></i>
              <span class="status-label">{{ (data?.isActive ?? false) ? 'Active' : 'Inactive' }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #contentTemplate let-data="dataVar" let-viewMode="currentView">
      <div class="grid skill-card-content">
        <div class="col-12 md:col-8 lg:col-9">
          <div class="font-semibold mb-1">Description</div>
          <div class="content-wrap">{{ data?.description }}</div>
        </div>
        <div class="col-12 md:col-4 lg:col-3">
          <div class="font-semibold mb-1">eQMS Scope(s)</div>
          <div *ngIf="data?.scopeDisplayNames?.length; else noScopeTemplate">
            <div class="content-wrap" *ngFor="let s of (data?.scopeDisplayNames ?? [])">
              {{ s }}
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #noScopeTemplate>
      <div class="content-wrap text-500">--</div>
    </ng-template>
  </app-panel-hub>
</div>

<div class="displayCenter" *ngIf="(pagedData.data.length === 0) && isPanelHubDataAvailable">
  <app-empty-results></app-empty-results>
</div>